import { z } from "zod";
import { fetchSymbol } from "../fetch/fetch-helper";

export async function getById(sectionId: string, url: string = '/', noIntercept?: boolean): Promise<HTMLElement> {
  const parsed = z.string().safeParse(sectionId);
  if (!parsed.success) throw new TypeError(`Invalid section id`);
  const response = await window[fetchSymbol].getHTML(url, { section_id: sectionId }, noIntercept);
  const section = response.querySelector(`.shopify-section`);
  if (!section) throw new Error(`Couldn't find section with id ${sectionId}`);
  return section as HTMLElement;
}